import React from 'react';

export const useUnsavedPromptInModal = () => {
  const [isFormDirty, setIsFormDirty] = React.useState(false);

  const confirmUnsavedPrompt = (message?: string) => {
    if (!isFormDirty) return true;
    return window.confirm(message ?? 'You have unsaved changes, are you sure you want to leave?');
  };
  return { isFormDirty, setIsFormDirty, confirmUnsavedPrompt };
};
